import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchQrTypeList = createAsyncThunk("fetchQrTypeList", async (params = {}, { rejectWithValue }) => {
    
    try {
        const response = await axiosHttp.get(`lcqr/getqrtypes`, { params }); 
        if (response.data && response.data.success === true) {
            return response.data.data || [];
        } else {
            return rejectWithValue(response.data?.message || "Failed to fetch QR Types");
        }
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
});

const QrTypeListSlice = createSlice({
    name: "QrTypeListSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchQrTypeList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchQrTypeList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });

        builder.addCase(fetchQrTypeList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default QrTypeListSlice.reducer;